import React from "react";

export default function PageLoader({ message = "Chargement…" }) {
  return (
    <div className="cere-loader-wrapper">
      <div className="cere-loader-card">
        {/* Logo CERE */}
        <div className="cere-loader-logo">
          CERE <span>Gabon</span>
        </div>

        {/* Spinner personnalisé */}
        <div className="cere-loader-spinner">
          <div className="cere-loader-ring"></div>
          <div className="cere-loader-ring cere-loader-ring--delay"></div>
        </div>

        {/* Message */}
        <p className="cere-loader-message">{message}</p>

        {/* Petits points animés */}
        <div className="cere-loader-dots">
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>
    </div>
  );
}